import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  getActivityLevelRequest: ['branchId', 'roleId', 'startDate', 'endDate', 'timezoneOffset'],
  getActivityLevelSuccess: ['response'],
  getActivityLevelFailure: null,

  getInfractionsRequest: ['branchId', 'roleId', 'startDate', 'endDate', 'timezoneOffset'],
  getInfractionsSuccess: ['response'],
  getInfractionsFailure: null,

  getUserInfractionsRequest: [
    'userId',
    'startDate',
    'endDate',
    'timezoneOffset',
    'currentPage',
    'pageSize',
    'search',
  ],
  getUserInfractionsSuccess: ['response'],
  getUserInfractionsFailure: null,

  getTotalMissedRepossessionsRequest: ['branchId', 'startDate', 'endDate', 'timezoneOffset'],
  getTotalMissedRepossessionsSuccess: ['response'],
  getTotalMissedRepossessionsFailure: null,

  getMissedRepossessionsRequest: [
    'branchId',
    'startDate',
    'endDate',
    'timezoneOffset',
    'currentPage',
    'pageSize',
    'search',
  ],
  getMissedRepossessionsSuccess: ['response'],
  getMissedRepossessionsFailure: null,

  getTotalSpottedVehiclesRequest: ['branchId', 'startDate', 'endDate', 'timezoneOffset'],
  getTotalSpottedVehiclesSuccess: ['response'],
  getTotalSpottedVehiclesFailure: null,

  getSpottedVehiclesRequest: [
    'branchId',
    'startDate',
    'endDate',
    'timezoneOffset',
    'currentPage',
    'pageSize',
    'search',
  ],
  getSpottedVehiclesSuccess: ['response'],
  getSpottedVehiclesFailure: null,

  getTotalRepossessionsRequest: ['branchId', 'startDate', 'endDate', 'timezoneOffset'],
  getTotalRepossessionsSuccess: ['response'],
  getTotalRepossessionsFailure: null,

  getRepossessionsRequest: [
    'branchId',
    'startDate',
    'endDate',
    'timezoneOffset',
    'currentPage',
    'pageSize',
    'search',
  ],
  getRepossessionsSuccess: ['response'],
  getRepossessionsFailure: null,

  getHoursWorkedRequest: ['branchId', 'startDate', 'endDate', 'timezoneOffset'],
  getHoursWorkedSuccess: ['response'],
  getHoursWorkedFailure: null,

  getTotalCommissionsRequest: ['branchId', 'startDate', 'endDate', 'timezoneOffset'],
  getTotalCommissionsSuccess: ['response'],
  getTotalCommissionsFailure: null,

  getCommissionsRequest: [
    'branchId',
    'commissionType',
    'startDate',
    'endDate',
    'timezoneOffset',
    'currentPage',
    'pageSize',
    'search',
  ],
  getCommissionsSuccess: ['commissionType', 'response'],
  getCommissionsFailure: ['commissionType'],

  // Clear all caches
  clearStatsRequest: null,
});

export const StatsCompanyTypes = Types;
export default Creators;
